module.exports = {
      id: "icon-home-plus-usage",
      viewBox: "0 0 27.193 24.672",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-home-plus",
      toString: function () {
        return this.url;
      }
    }